import React, { useState, useEffect } from 'react';
import { ImageWithFallback } from './utils/ImageWithFallback';
import { poolId } from './variables/poolid';
const { getTip } = await  import('../lib/queryTip');

const TopHeaders: React.FC = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [mithrilUrl, setMithrilUrl] = useState<string | null>(null);

  useEffect(() => {
    const fetchMithrilStatus = async () => {
      try {
        const tipData = await getTip();
        if (tipData?.currEpoch !== undefined) {
          const response = await fetch(
            `/api/mithril-signer?epoch=${tipData.currEpoch}&party_id=${poolId}`
          );
          const data = await response.json();

          if (data.isRegistered) {
            const url = `https://mithril.network/explorer/registrations?aggregator=https://aggregator.release-mainnet.api.mithril.network/aggregator&epoch=${tipData.currEpoch}`;
            setMithrilUrl(url);
          } else {
            setMithrilUrl(null); // Hide Mithril icon if not registered
          }
        }
      } catch (error) {
        console.error('Failed to fetch Mithril registration status:', error);
        setMithrilUrl(null); // Hide Mithril icon on error
      }
    };

    fetchMithrilStatus();
  }, []);

  return (
    <div className="flex flex-col p-4 bg-black-800 bg-opacity-100 rounded-lg">
      <div className="flex items-center justify-between relative">
        {/* Left Section */}
        <div className="flex items-center space-x-4">
          <ImageWithFallback
            src="https://data.snakepool.link/cdn/logo.svg"
            fallbackSrc="/logo.svg"
            alt="SN₳KE Logo"
            className="h-14 w-auto"
            width={56}
            height={56}
            loading="lazy"
          />
          <div className="font-sans text-white text-2xl font-bold md:font-bold sm:font-bold">
            SN₳KE Cardano Staking
          </div>
        </div>

        {/* Right Section */}
        {mithrilUrl && (
          <a
            href={mithrilUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="relative flex items-center"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <ImageWithFallback
              src="https://data.snakepool.link/cdn/mithril.svg"
              fallbackSrc="/mithril.svg"
              alt="Mithril Icon"
              className="h-5 w-5 ml-4 mt-1"
              width={32}
              height={32}
              loading="lazy"
            />
            {showTooltip && (
              <div className="absolute bg-gray-900 text-white text-xs px-2 py-2 rounded-lg shadow-md border border-gray-600 transform transition-all duration-200 ease-in-out whitespace-nowrap mt-16">
                Mithril Signer
              </div>
            )}
          </a>
        )}
      </div>
    </div>
  );
};

export { TopHeaders };
